import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiEventsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_events"}/>
}
